import { useContext } from "react";
import { CartContext } from "@context/CartProvider";
import useDeviceDetect from "@hooks/useDeviceDetect";

import IconCloseSideCart from "@svgs/close-delete.svg";

function SideCartHeader({ sideCartHeaderRef, sideCartTag, toggleCart }) {
  const { itemsInCart } = useContext(CartContext);
  const { isMobile } = useDeviceDetect();

  return (
    <div
      className="flex justify-between flex px-[15px] py-[16px] desktop:px-[20px] desktop:py-[20px] items-center"
      ref={sideCartHeaderRef}
    >
      <div className="flex items-center">
        <span className="typo-h2 font-bold capitalize">
          Your cart {itemsInCart > 0 ? `(${itemsInCart})` : ""}
        </span>

        {sideCartTag && sideCartTag.length > 0 && (
          <div
            className="ml-[10px] mt-[2px] px-[7px] py-[3px] typo-micro-bold-caps rounded-[4px] text-center uppercase"
            style={{
              backgroundColor: isMobile
                ? sideCartTag[0].backgroundColorTag.mobile
                : sideCartTag[0].backgroundColorTag.desktop,
              color: isMobile
                ? sideCartTag[0].textColorTag.mobile
                : sideCartTag[0].textColorTag.desktop,
              border: `1px solid ${
                isMobile ? sideCartTag[0].textColorTag.mobile : sideCartTag[0].textColorTag.desktop
              }`,
            }}
          >
            <span>{sideCartTag[0].titleTag}</span>
          </div>
        )}
      </div>

      <IconCloseSideCart
        className="cursor-pointer"
        onClick={toggleCart}
        width="15px"
        height="15px"
        fill="none"
        stroke="#000000"
      />
    </div>
  );
}

export default SideCartHeader;
